import { handleActions } from 'redux-actions';
import { defaultMutedTagsWidgetState } from './defaults';
import { MutedTagsWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  INITIAL_SAVE_REQUEST_META,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  setMutedTagsWidgetBlacklistedTags,
  saveMutedTags,
  saveMutedTagsSuccess,
  saveMutedTagsFailure,
} from './actions';

const mergeMutedTagsWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultMutedTagsWidgetState
);

export default handleActions<MutedTagsWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (state, action: ReturnType<typeof initBrowsingPage>) => {
      const data: MutedTagsWidgetData['initialData'] = {
        blacklistedTags: action.payload.data.blacklistedTags ?? [],
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setMutedTagsWidgetBlacklistedTags.toString()]: (
      state,
      action: ReturnType<typeof setMutedTagsWidgetBlacklistedTags>
    ) =>
      mergeMutedTagsWidgetDataChange(state, {
        blacklistedTags: action.payload.blacklistedTags,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveMutedTags,
      successAction: saveMutedTagsSuccess,
      failureAction: saveMutedTagsFailure,
    }),
  },
  defaultMutedTagsWidgetState
);
